var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 1200,
    viewBox: "0 0 1200 1200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1042_32757)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 1200,
    rx: 150,
    fill: "url(#paint0_linear_1042_32757)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter0_f_1042_32757)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 590.41,
    cy: 600,
    rx: 380.41,
    ry: 390,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1042_32757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.813 924.737L409.55 295.397C411.965 280.748 424.629 270 439.476 270H694.286C974.835 300.33 944.505 740.11 633.626 755.275H537.536C522.916 755.275 510.376 765.705 507.714 780.082L478.989 935.193C476.327 949.569 463.788 960 449.167 960H335.738C317.018 960 302.768 943.208 305.813 924.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.813 924.737L409.55 295.397C411.965 280.748 424.629 270 439.476 270H694.286C974.835 300.33 944.505 740.11 633.626 755.275H537.536C522.916 755.275 510.376 765.705 507.714 780.082L478.989 935.193C476.327 949.569 463.788 960 449.167 960H335.738C317.018 960 302.768 943.208 305.813 924.737Z",
    stroke: "url(#paint1_linear_1042_32757)",
    strokeWidth: 15
  })), /*#__PURE__*/React.createElement("path", {
    d: "M589.773 651.491C560.024 651.634 535.956 645.64 517.569 633.51C501.965 622.991 490.84 609.198 484.195 592.132C482.088 586.721 484.744 580.766 489.892 578.08L531.379 556.43C538.123 552.911 546.269 556.444 550.364 562.854C559.491 577.136 574.511 584.228 595.426 584.127C617.207 584.022 629.262 577.589 631.591 564.828C633.142 556.055 626.998 548.779 613.158 543.002C611.027 541.95 601.316 538.544 584.022 532.783C559.545 524.666 541.031 513.599 528.479 499.581C515.927 485.563 511.717 466.326 515.85 441.868C520.243 416.347 532.233 396.5 551.821 382.327C571.674 367.888 595.147 360.603 622.24 360.473C645.615 360.36 665.696 365.842 682.484 376.917C696.651 385.897 707.718 398.193 715.683 413.805C718.514 419.352 716.045 425.984 710.57 428.953L670.939 450.439C664.674 453.835 656.99 451.077 652.744 445.353C644.028 433.601 632.108 427.762 616.986 427.834C600.252 427.915 590.718 433.937 588.385 445.902C586.824 452.55 589.241 458.117 595.638 462.601C602.033 466.821 614.011 471.943 631.571 477.968C643.81 482.159 653.79 486.095 661.511 489.777C669.232 493.458 677.227 498.865 685.496 505.997C694.029 512.863 699.782 521.734 702.757 532.61C705.73 543.221 706.056 555.836 703.736 570.457C699.081 596.777 686.693 616.891 666.573 630.8C646.451 644.444 620.851 651.341 589.773 651.491Z",
    fill: "url(#paint2_linear_1042_32757)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    width: 1170,
    height: 1170,
    rx: 135,
    stroke: "url(#paint3_linear_1042_32757)",
    strokeWidth: 30
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1042_32757",
    x: -183,
    y: -183,
    width: 1546.82,
    height: 1566,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 196.5,
    result: "effect1_foregroundBlur_1042_32757"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1042_32757",
    x: 171.898,
    y: 256.5,
    width: 848.652,
    height: 957,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 120
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 63
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1042_32757"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1042_32757",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1042_32757",
    x1: 210,
    y1: -60,
    x2: 1065,
    y2: 1170,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#069AE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03557D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1042_32757",
    x1: 225,
    y1: 165,
    x2: 1020,
    y2: 1065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#087EB0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1042_32757",
    x1: 375,
    y1: 270.004,
    x2: 780,
    y2: 780.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#039BE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#042F88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1042_32757",
    x1: -136.386,
    y1: -85.0483,
    x2: 1291.73,
    y2: 1367.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#029DDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003B53"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1042_32757"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 1200,
    rx: 150,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInner);
export default __webpack_public_path__ + "static/media/Inner.3cadb9dbc4728a93976ac1b6449ea270.svg";
export { ForwardRef as ReactComponent };